export const DEFAULT_TRANSITION_FUNC = 'cubic-bezier(.2,0.95,.4,0.95)';
export const DEFAULT_TRANSITION_DURATION = '0.38s';